import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { User } from '../models/user.model';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private url = environment.url;
  public user: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public token: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private userAuthenticated = new BehaviorSubject<User | undefined>(undefined);

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    this.load();
  }

  load() {
    this.token.next(localStorage.getItem('token'));
    this.user.next(JSON.parse(localStorage.getItem('user')));
  }

  login(user: User) {
    return this.http.post(`${this.url}/api/v2/auth/clipping/login`, user).pipe(
      tap((response: any) => {
        // console.log(response)
        this.token.next(response.data.token);
        localStorage.setItem('token', response.data.token);
      })
    );
  }

  loginUser(user) {
    this.user.next(user.data.user);
    localStorage.setItem('user', JSON.stringify(user.data.user));
    /*
        return this.http.get(`/authenticate/user`).pipe(
          tap((response: any) => {
            this.user.next(response.user);
            localStorage.setItem('user', JSON.stringify(response.user));
          })
        );*/
  }

  logout() {
    localStorage.clear();
    this.user.next(null);
    this.token.next(null);
    this.router.navigate(['/login']);
  }

  getUser() {
    return this.http.get(`/users/${this.user.value.id}`).pipe(
      tap((response: any) => {
        this.user.next(response.user);
        localStorage.setItem('user', JSON.stringify(response.user));
      })
    );
  }

  update(user: any) {
    return this.http.put(`/users/${this.user.value.id}`, user).pipe(
      tap((response: any) => {
        this.user.next(response.user);
        localStorage.setItem('user', JSON.stringify(response.user));
      })
    );
  }

  recoverPasswordOne(email) {
    return this.http.post(`${this.url}/api/sendTemporaryPassword`, email);
  }

  recoverPasswordTwo(data) {
    return this.http.post(`${this.url}/api/resetPassword`, data);
  }

  passwordChange(newPassword) {
    return this.http.post(`${this.url}/api/clientes/new/changePassword`, { id: this.user.value.id, newPassword }).pipe(
      tap((response: any) => {
        this.user.next(response.usuario);
        localStorage.setItem('user', JSON.stringify(response.usuario));
      })
    );
  }

  /**
   *
   * @param data: Object { oldPassword: string, password: string, password_confirmation: string }
   * @returns Observable
   */
  passwordUpdate(data: object) {
    const userId = this.user.value.id;
    return this.http.put(`${this.url}/api/v2/profile/password/${userId}`, data);
  }

  recoveryPasswordUpdate(data: object) {
    return this.http.post(`${this.url}/api/v2/update-password`, data);
  }

  getInfoBusiness() {
    return this.http.get(`/informacionEmpresa`)
  }

  public savePermisosRolesInLocalStorage(response: any): void {
    const userStr = localStorage.getItem('user');
    // localStorage.setItem('access_token', response.token);
    if (!userStr) {
      console.warn('No hay usuario en el localStorage');
      return;
    }

    try {
      const user = JSON.parse(userStr);

      // Asegurar que permissions sea un array
      if (!Array.isArray(response.user.permissions)) {
        response.user.permissions = Object.values(response.user.permissions);
      }
      if (!Array.isArray(response.user.roles)) {
        response.user.roles = Object.values(response.user.roles);
      }

      // Asignar nuevos valores
      user.roles = response.user.roles;
      user.permissions = response.user.permissions;
      //console.log("este es el del tenant", user);
      this.user.next(user);
      // Guardar el objeto actualizado en el localStorage
      localStorage.setItem('user', JSON.stringify(user));

    } catch (error) {
      console.error('Error al parsear el usuario desde localStorage:', error);
    }
  }

}
